/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
  $('.ProductList:not(.ProductList--carousel)').packery({
        columnWidth: '.Grid__Cell',
        itemSelector: '.Grid__Cell'
    });

  
});

// Tabbed steps for bundle builder

$(document).on('click', '.rebuy-bundle-builder__step-tabs-wrapper .rebuy-bundle-builder__step-tab', function() {
  $(this).addClass('active').siblings().removeClass('active');
});

// Finds the header element and wraps the word "to" in a span (to override text-transform).
// If the element or the word isn't found yet, it keeps retrying until they appear.

function wrapToWord() {
  const el = document.querySelector('.rebuy-bundle-builder__main-header-title');
  if (!el) return false;

  const html = el.innerHTML;
  if (!/\bto\b/.test(html)) return false;

  el.innerHTML = html.replace(
    /\bto\b/,
    '<span style="text-transform: lowercase;">to</span>'
  );

  return true;
}

if (!wrapToWord()) {
  const interval = setInterval(() => {
    if (wrapToWord()) {
      clearInterval(interval);
    }
  }, 20);
}

(function decodeHtmlEntities() {
  const selectors = ['.Alert__ErrorItem'];
  
  if (!Array.isArray(selectors) || selectors.length === 0) return;

  const textarea = document.createElement('textarea');

  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      const originalHtml = el.innerHTML;
      textarea.innerHTML = originalHtml;
      el.innerHTML = textarea.value;
    });
  });
})();

